// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__PfJK5","col":"styles_col__1ZBR7","fulfillmentStatus":"styles_fulfillmentStatus__3N6dz","emailCol":"styles_emailCol__2KeNa"};